import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://1afac252a9a48b94afd2f77a79ca905e@o4509893577211904.ingest.us.sentry.io/4509893579309056",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/astro/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [
    Sentry.captureConsoleIntegration({
      levels: ["error"],
      // levels: ["error", "warn", "log", "info", "debug", "trace"],
    }),
  ],

  // https://docs.sentry.io/platforms/javascript/configuration/filtering/
  // You can use the ignoreErrors option to filter out errors that match a certain pattern.
  // This option receives a list of strings and regular expressions to match against the error message.
  // When using strings, partial matches will be filtered out. If you need to filter by exact match, use regex patterns instead.
  ignoreErrors: ["Amplitude Logger"],
});